import React, { useEffect, useState } from 'react';
import '../styles/VisionMission.css';
import logo from "../assets/image0.png";

const VisionMission = () => {
  const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      setIsVisible(true);
    }, []);

  return (

    <>
      {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Who We Are</h1>
          </div>
        </div>
      </section>
    <div className="vision-mission-container">
      {/* Header Section */}
      <div className="vm-header">
        <div className="vm-logo-section">
          <img src={logo} alt="School Logo" className="vm-logo-img" />
          <div className="vm-established">
            <h2>Estd.</h2>
            <p>1951</p>
          </div>
        </div>
        <div className="vm-header-text">
          <h1>Seth G.L Bihani S.D Sc Sec School</h1>
          <p className="vm-tagline">
            A warm welcome to Seth. G.L Bihani Sc Sec. School in SriGanganagar! It is our honour and privilege to have you as part of our prestigious institution. As you embark on this new educational journey, we extend our heartfelt greetings and best wishes for your success. At Seth. G.L Bihani Sc Sec. School, we are committed to providing our students with an enriching and transformative learning experience. Our dedicated faculty and staff strive to create an environment where intellectual curiosity, creativity, and personal growth are nurtured. We believe that every student has unique talents and potential, and our goal is to help you discover and develop those talents to the fullest. Through our comprehensive academic program, extracurricular activities, and supportive community, we aim to empower you with the knowledge, skills, and confidence you need to excel in your chosen field and make a positive impact on the world. As you begin your journey at Seth. G.L Bihani Sc Sec. School, we encourage you to embrace new experiences, challenge yourself intellectually, and actively engage with your peers and teachers. We are confident that your time here will be filled with growth, discovery, and lifelong memories. Once again, a warm welcome to Seth. G.L Bihani Sc Sec. School! We look forward to begleiten you on this exciting educational adventure.
          </p>
        </div>
      </div>

      {/* Vision, Mission, Core Values Section */}
      <div className="vm-cards-container">
        {/* Vision Card */}
        <div className="vm-card">
          <div className="vm-card-header">
            <h2>Our Vision</h2>
          </div>
          <div className="vm-card-body">
            <p>
              At Seth G.L Bihani S.D.Sc. Sec. School, We Envision A Vibrant And Inclusive Learning Community That Fosters Intellectual Curiosity, Personal Growth, And Professional Excellence. Our Aim Is To Empower Students With The Knowledge, Skills, And Values Needed To Thrive In A Rapidly Changing World.
            </p>
          </div>
        </div>

        {/* Mission Card */}
        <div className="vm-card">
          <div className="vm-card-header">
            <h2>Our Mission</h2>
          </div>
          <div className="vm-card-body">
            <p>
              Our Mission Is To Provide A Supportive And Stimulating Environment Where Students Can Explore Their Passions, Expand Their Horizons, And Achieve Their Full Potential. Through Innovative Teaching Methods, Practical Experiences, And A Wide Range Of Academic Programs, We Strive To Nurture Critical Thinking, Creativity, And A Lifelong Love For Learning. We Are Committed To Promoting Ethical Values, Social Responsibility, And Cultural Diversity, Preparing Our Students To Become Responsible Global Citizens Who Make A Positive Impact In Their Communities.
            </p>
          </div>
        </div>

        {/* Core Values Card */}
        <div className="vm-card">
          <div className="vm-card-header">
            <h2>Core Values</h2>
          </div>
          <div className="vm-card-body">
            <p>
              We Encourage Creativity And Innovation, Nurturing An Environment That Fosters Critical Thinking, Problem-Solving, And Entrepreneurial Spirit. Community Engagement: We Actively Engage With The Local Community, Promoting Social Responsibility And Contributing To The Betterment Of Society Through Various Outreach Programs.We Instill Professionalism In Our Students, Equipping Them With The Necessary Skills And Knowledge To Excel In Their Chosen Careers.
            </p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default VisionMission;